import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import theme from '@theme/Theme'

export const BUTTON_HEIGHT = 80

interface Props {
  label: string
  onClick: () => void
  style?: 'warning' | 'urgent'
}

const AlertButton = ({ label, onClick, style = 'warning' }: Props) => {
  return (
    <ButtonContainer activeOpacity={0.9} onPress={onClick} status={style}>
      <Label>{label}</Label>
      <IconContainer status={style}>
        <Icon name="full-arrow" size={24} color={theme.colors.background} />
      </IconContainer>
    </ButtonContainer>
  )
}

export default AlertButton

const ButtonContainer = styled(TouchableOpacity)<{ status: 'warning' | 'urgent' }>`
  background-color: ${(props) =>
    props.status === 'warning' ? props.theme.colors.alertButtonLight : props.theme.colors.priority};
  border-radius: 8px;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: ${BUTTON_HEIGHT}px;
`
const Label = styled(Text)`
  flex: 1;
  margin-right: 16px;
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Caption1 : props.theme.fonts.Callout)};
`
const IconContainer = styled(View)<{ status: 'warning' | 'urgent' }>`
  border-radius: 36px;
  height: 40px;
  width: 40px;
  background-color: ${(props) =>
    props.status === 'warning' ? props.theme.colors.alertButton : props.theme.colors.negate};
  align-items: center;
  justify-content: center;
`
